import { Injectable } from '@angular/core';
import { AssetCollection, Asset } from 'contentful';
import { get } from 'lodash';

import { AssetMapped, AssetsCollection } from './_interfaces_/asset.mapped.interface';

@Injectable()
export class AssetMapperService {
  constructor() {}

  mapAssetCollectionFirstItem(assets: AssetCollection, id: string, urlQuery: string = ''): AssetMapped | null {
    const asset = get(assets, 'items[0]', null);
    return this.mapAsset(asset, id, urlQuery);
  }

  mapAsset(asset: Asset, id: string, urlQuery: string = ''): AssetMapped | null {
    const fields = get(asset, 'fields', null);
    return fields ? { id, title: fields.title, url: `${fields.file.url}${urlQuery}` } : null;
  }

  concatAssets(assetsArray: AssetMapped[] | null, oldAssets: AssetsCollection): AssetsCollection {
    const allAssets = { ...oldAssets };
    if (assetsArray) {
      assetsArray.forEach((asset) => {
        allAssets[asset.id] = asset;
      });
    }
    return allAssets;
  }
}
